import type { TOC } from "@ember/component/template-only";

import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import autofocusable from "glesys-controlpanel/modifiers/autofocusable";

interface GInputSignature {
  Element: HTMLInputElement;
}

const GInput: TOC<GInputSignature> = <template>
  <input
    class="w-full border text-sm border-gray-200 focus:border-gray-400 rounded-sm p-3 mb-4"
    data-test-g-input
    type="text"
    {{autofocusable}}
    {{mergeClasses}}
    ...attributes
  />
</template>;

export default GInput;

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    GInput: typeof GInput;
  }
}
